import { render, staticRenderFns } from "./BaseListItemShell.vue?vue&type=template&id=71b4f862"
import script from "./BaseListItemShell.vue?vue&type=script&lang=ts"
export * from "./BaseListItemShell.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports